export const INSTANT_QR_PROTOTYPE_STATES = Object.freeze([
  "qr",
  "phone",
  "code",
  "linked",
  "configured",
]);

export const INSTANT_QR_PROTOTYPE_POLL_DELAY_MS = 900;
export const INSTANT_QR_PROTOTYPE_READY_DELAY_MS = 900;

export function shouldEnableInstantQrPrototype({ onboardingDesignMode = false } = {}) {
  return onboardingDesignMode === true;
}

export function getInstantQrPrototypeState(search = "") {
  const requestedState = String(new URLSearchParams(search).get("prototype") || "")
    .trim()
    .toLowerCase();
  return INSTANT_QR_PROTOTYPE_STATES.includes(requestedState) ? requestedState : "qr";
}

export function buildInstantQrPrototypeSearch(search = "", state = "qr") {
  const params = new URLSearchParams(search);
  params.set("prototype", getInstantQrPrototypeState(`?prototype=${encodeURIComponent(state)}`));
  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
}

export function shouldResetInstantQrPrototypeOnReload(search = "", navigationType = "navigate") {
  return navigationType === "reload" && getInstantQrPrototypeState(search) !== "qr";
}
